import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50">
      <div className="text-center px-4">
        <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-6">
          <i className="ri-emotion-sad-line text-3xl"></i>
        </div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
          页面未找到
        </h1>
        <p className="text-foreground-500 mb-8">
          您访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}